module.exports = __webpack_public_path__ + "static/media/hill01.cef38472.png";